<template>
    <submenu-page
        eyebrow="SCHOOL COMMUNICATION"
        title="School Website"
        description="Manage website news, blogs, galleries, events and shared resources."
        count-label="website tools"
    >
        <SubMenu />
    </submenu-page>
</template>
<script>


import SubMenu from './SubMenu.vue';
export default {
  components: {
    SubMenu
  },
  data() {
    return {
      accessDetails: null,
    };
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];   
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    }
  }
};
</script>
<style></style>
